import React, { useState, useEffect,useRef } from "react";
import Footer from "../common/Footer";
import Navigation from "../common/Navigation";
import Sidebar from "../common/Sidebar";
import CommonService from "../../services/CommonService";
import Swal from "sweetalert2";

const Pan = () => {
    const [isLoading, setIsLoading] = useState(false);
    const formRef = useRef(null);
    const [bankaccount, setBankaccount] = useState("");
    const [ifsc, setIfsc] = useState("");
    const [bankDetails, setbankDetails] = useState();
    const handleCancel = () => {
        // Reset the form
        formRef.current.reset();
        setBankaccount("");
        setIfsc("");
        setbankDetails(null);
    }

    const panFormSubmit = (event) =>{
        event.preventDefault(); // stop page reload
        setIsLoading(true);
        var data = {
            "bankAccount":bankaccount,
            "ifsc":ifsc
        };
        CommonService.bankVarification(data)
        .then((response) => {
            response = response.data
            if(response.status === 200 && response.data.status ==='success'){
                setbankDetails(response.data);
                setIsLoading(false);
            }else if (response.data.status === 'error') {
                    Swal.fire({
                        icon: 'error',
                        title: response.data.data?.status || 'Error',
                        text: response.data.data?.message || 'An error occurred during bank verification.',
                    })
                    setIsLoading(false);
                    setbankDetails(null);
            }else{
                
                Swal.fire({
                    icon: 'error',
                    title: response.data.status,
                    text: response.data.message,
                })
                setIsLoading(false);
                setbankDetails(null);
            }
        })
        .catch((error) => {
            console.log('An error occurred:', error.response.data.data);
            if(error.response.data.status === 510){
                Swal.fire({
                    icon: 'error',
                    title: error.response.data.status,
                    text: error.response.data.data,
                })
                setIsLoading(false);
                setbankDetails(null);
            }else{
                Swal.fire({
                    icon: 'error',
                    title: error.response.data.status, 
                    text: error.response.data.data.error.message || "Something went wrong. Please try again",
                })
                setIsLoading(false);
                setbankDetails(null);
            }
        });
    }
    return (
        <>
        <div className="layout-wrapper layout-content-navbar">
            <div className="layout-container">
                <Sidebar/>
                <div className="layout-page">
                    <Navigation/>
                    <div className="content-wrapper">
                        <div className="container-xxl flex-grow-1 container-p-y">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card h-100">
                                        <div className="card-body"> 
                                            <div className="row">
                                                <h5 className="card-header">Bank Verification Report</h5>
                                                <hr className="hr-line"/>
                                            </div>
                                            {isLoading ? (
                                                <div className="d-flex justify-content-center">
                                                    <div className="sk-fold sk-primary">
                                                        <div className="sk-fold-cube"></div>
                                                        <div className="sk-fold-cube"></div>
                                                        <div className="sk-fold-cube"></div>
                                                        <div className="sk-fold-cube"></div>
                                                    </div>
                                                </div>
                                            ) : ( 
                                            <form className="card-body" ref={formRef} style={{paddingTop:"0px", paddingLeft:"0px"}} data-parsley-validate="" onSubmit={ panFormSubmit }>
                                                <div className="row">    
                                                    <div className="col-md-4">
                                                        <label className="form-label" htmlFor="multicol-username">Bank Account</label>
                                                        <input type="text" value={bankaccount}
                                                            onChange={(e) => { setBankaccount(e.target.value.toUpperCase()) }} required data-parsley-required="true" 
                                                            className="form-control" placeholder="Enter bank account number"
                                                            maxLength={20} 
                                                            />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label className="form-label" htmlFor="multicol-username">IFSC</label>
                                                        <input type="text" value={ifsc}
                                                            onChange={(e) => { setIfsc(e.target.value.toUpperCase()) }} required data-parsley-required="true" 
                                                            className="form-control" placeholder="Enter ifsc"
                                                            
                                                            />
                                                    </div>
                                                </div>
                                               <div className="pt-4">
                                                    <button type="submit" className="btn btn-primary me-sm-3 me-1">Find Status</button>
                                                    <button type="button" className="btn btn-label-secondary" onClick={handleCancel}>Reset</button>
                                                </div>
                                            </form> 
                                            )} 
                                            
                                            { bankDetails ? (
                                                <div className="row">
                                                    <div className="col-md-7">
                                                        <ul className="nav nav-pills flex-column flex-sm-row mb-4">
                                                            <p className="nav-link active" style={{fontSize:"19px"}}>
                                                                <i className='ti-xs ti ti-user-check me-1'></i> BANK Details
                                                            </p>
                                                        </ul>
                                                        <div className="card-body"  style={{paddingTop:"0px"}}>
                                                            <div className="row" style={{background: '#ebe9e9'}}>
                                                                <div className=" col-6 col-md-6">
                                                                   <b>Name</b> 
                                                                </div>
                                                                <div className=" col-6 col-md-6" style={{textAlign:"right"}}>
                                                                    {bankDetails?.data?.name_at_bank ? bankDetails?.data?.name_at_bank : 'NA'}
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className=" col-6 col-md-6">
                                                                    <b>Bank Name</b>
                                                                </div>
                                                                <div className=" col-6 col-md-6" style={{textAlign:"right"}}>
                                                                    {bankDetails?.data?.bank_name ? bankDetails?.data?.bank_name : 'NA'}
                                                                </div>
                                                            </div>
                                                            <div className="row" style={{background: '#ebe9e9'}}>
                                                                <div className=" col-6 col-md-6">
                                                                    <b>Branch</b>
                                                                </div>
                                                                <div className=" col-6 col-md-6" style={{textAlign:"right"}}>
                                                                    {bankDetails?.data?.branch ? bankDetails?.data?.branch : 'NA'}
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className=" col-6 col-md-6">
                                                                   <b>City</b> 
                                                                </div>
                                                                <div className=" col-6 col-md-6" style={{textAlign:"right"}}>
                                                                    {bankDetails?.data?.city ? bankDetails?.data?.city : 'NA'}
                                                                </div>
                                                            </div>
                                                            
                                                            <div className="row" style={{background: '#ebe9e9'}}>
                                                                <div className=" col-6 col-md-6">
                                                                    <b>MICR</b>
                                                                </div>
                                                                <div className=" col-6 col-md-6" style={{textAlign:"right"}}>
                                                                    {bankDetails?.data?.micr ? bankDetails?.data?.micr : 'NA'}
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className=" col-6 col-md-6">
                                                                    <b>Account Number</b>
                                                                </div>
                                                                <div className=" col-6 col-md-6" style={{ textAlign: "right" }}>
                                                                    {bankDetails?.bankAccount ? bankDetails?.bankAccount : 'NA'}
                                                                </div>
                                                            </div>
                                                            <div className="row" style={{background: '#ebe9e9'}}>
                                                                <div className=" col-6 col-md-6">
                                                                    <b>IFSC Code</b>
                                                                </div>
                                                                <div className=" col-6 col-md-6" style={{textAlign:"right"}}>
                                                                    {bankDetails?.ifsc ? bankDetails?.ifsc : 'NA'}
                                                                </div>
                                                            </div>
                                                           <div className="row">
                                                                    <div className=" col-6 col-md-6">
                                                                        <b>Account Status</b>
                                                                    </div>
                                                                    <div className=" col-6 col-md-6" style={{ textAlign: "right", color: bankDetails?.data?.account_status === 'VALID' ? 'green' : 'red' }}>
                                                                        {bankDetails?.data?.account_status ? bankDetails?.data?.account_status : 'NA'}
                                                                    </div>
                                                                </div>
                                                            <div className="row" style={{background: '#ebe9e9'}}>
                                                                <div className=" col-6 col-md-6">
                                                                    <b>Account Status Code</b>
                                                                </div>
                                                                <div className=" col-6 col-md-6" style={{ textAlign: "right" }}>
                                                                    {bankDetails?.data?.account_status_code ? bankDetails?.data?.account_status_code : 'NA'}
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className=" col-6 col-md-6">
                                                                    <b>Message</b>
                                                                </div>
                                                                <div className=" col-6 col-md-6" style={{ textAlign: "right" }}>
                                                                    {bankDetails?.msg ? bankDetails?.msg : 'NA'}
                                                                </div>
                                                            </div>

                                                         </div>
                                                    </div>
                                                    <div className="col-md-5">
                                                        <ul className="nav nav-pills flex-column flex-sm-row mb-4">
                                                            <p className="nav-link active" style={{fontSize:"19px"}}>
                                                            <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  className="icon icon-tabler icons-tabler-outline icon-tabler-clock-12"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M3 12a9 9 0 0 0 9 9m9 -9a9 9 0 1 0 -18 0" /><path d="M12 7v5l.5 .5" /><path d="M18 15h2a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-1a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h2" /><path d="M15 21v-6" /></svg> &nbsp;  API HEALTH CHECK
                                                            </p>
                                                        </ul>
                                                        <div className="card-body"  style={{paddingTop:"0px"}}>
                                                            <div className="row">
                                                                <div className=" col-6 col-md-6">
                                                                <b> Request Time</b>
                                                                </div>
                                                                <div className=" col-6 col-md-6" style={{textAlign:"right"}}>
                                                                    {bankDetails.requestTimestamp}
                                                                </div>
                                                            </div>
                                                            
                                                            <div className="row" style={{background: '#ebe9e9'}}>
                                                                <div className=" col-6 col-md-6">
                                                                    <b>Response Time</b>
                                                                </div>
                                                                <div className=" col-6 col-md-6" style={{textAlign:"right"}}>
                                                                    {bankDetails.responseTimestamp}
                                                                </div>
                                                            </div>
                                                            
                                                            <div className="row">
                                                                <div className=" col-6 col-md-6">
                                                                <b>Latency(sec)</b> 
                                                                </div>
                                                                <div className=" col-6 col-md-6" style={{textAlign:"right"}}>
                                                                    {bankDetails.totalTime}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        
                                                        
                                                    </div>
                                                </div>
                                            ) : ( '' )}   
                                            
                                        </div>
                                    </div>    
                                </div>
                             </div> 
                        </div>
                        <Footer/>
                        <div className="content-backdrop fade"></div>
                    </div>
                </div>
            </div>
            <div className="layout-overlay layout-menu-toggle"></div>
            <div className="drag-target"></div>
        </div>    
    </>
    )
}   

export default Pan;